(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-vvc-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-vvc-slide]'));
    var prevBtn = root.querySelector('[data-vvc-prev]');
    var nextBtn = root.querySelector('[data-vvc-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vvc-dot]'));
    var total = slides.length;

    if (total === 0) return;

    var setSize = total >= 3 ? total / 3 : total;
    var scrollTimeout;
    var isJumping = false;

    function gapPx() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function centerScrollLeft(index) {
      var slide = slides[index];
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      var slideCenter = slideRect.left + slideRect.width / 2 - trackRect.left + track.scrollLeft;
      return slideCenter - trackRect.width / 2;
    }

    function scrollToIndex(index, smooth) {
      track.scrollTo({ left: centerScrollLeft(index), behavior: smooth ? 'smooth' : 'auto' });
    }

    function findClosestIndex() {
      var trackRect = track.getBoundingClientRect();
      var centerX = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var r = slide.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - centerX);
        if (d < closestDist) {
          closestDist = d;
          closest = i;
        }
      });
      return closest;
    }

    function pauseAll() {
      slides.forEach(function (s) {
        var v = s.querySelector('[data-vvc-video]');
        if (v && !v.paused) v.pause();
        s.classList.remove('is-active');
        updatePlayIcon(s, false);
      });
    }

    function setActive(index) {
      var slide = slides[index];
      slide.classList.add('is-active');
      var v = slide.querySelector('[data-vvc-video]');
      if (v) {
        v.currentTime = 0;
        var playPromise = v.play();
        if (playPromise) playPromise.catch(function () {});
        updatePlayIcon(slide, true);
      }
      updateDots(index);
    }

    function updateDots(index) {
      if (dots.length === 0) return;
      var realIndex = index % setSize;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === realIndex);
      });
    }

    function onSettled() {
      if (isJumping) return;
      pauseAll();
      var idx = findClosestIndex();
      setActive(idx);
      maybeLoopReset(idx);
    }

    function maybeLoopReset(index) {
      if (total < 3) return;
      if (index < setSize) {
        jumpBy(setSize);
      } else if (index >= setSize * 2) {
        jumpBy(-setSize);
      }
    }

    function jumpBy(slideCount) {
      isJumping = true;
      var delta = slideCount * (slides[0].getBoundingClientRect().width + gapPx());
      track.scrollLeft += delta;
      requestAnimationFrame(function () {
        isJumping = false;
      });
    }

    function next() {
      var idx = findClosestIndex();
      scrollToIndex(idx + 1, true);
    }

    function prev() {
      var idx = findClosestIndex();
      scrollToIndex(idx - 1, true);
    }

    function goToRealIndex(realIndex) {
      var current = findClosestIndex();
      var currentReal = current % setSize;
      var target = current + (realIndex - currentReal);
      scrollToIndex(target, true);
    }

    function updatePlayIcon(slide, playing) {
      var playIcon = slide.querySelector('[data-icon="play"]');
      var pauseIcon = slide.querySelector('[data-icon="pause"]');
      if (playIcon) playIcon.style.display = playing ? 'none' : 'block';
      if (pauseIcon) pauseIcon.style.display = playing ? 'block' : 'none';
    }

    function updateMuteIcon(slide, muted) {
      var m = slide.querySelector('[data-icon="muted"]');
      var u = slide.querySelector('[data-icon="unmuted"]');
      if (m) m.style.display = muted ? 'block' : 'none';
      if (u) u.style.display = muted ? 'none' : 'block';
    }

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(onSettled, 130);
    });

    track.addEventListener('click', function (e) {
      var playBtn = e.target.closest('[data-vvc-playpause]');
      var muteBtn = e.target.closest('[data-vvc-mute]');

      if (playBtn) {
        var slide = playBtn.closest('[data-vvc-slide]');
        var v = slide.querySelector('[data-vvc-video]');
        if (!v) return;
        if (v.paused) {
          v.play();
          updatePlayIcon(slide, true);
        } else {
          v.pause();
          updatePlayIcon(slide, false);
        }
      }

      if (muteBtn) {
        var slide2 = muteBtn.closest('[data-vvc-slide]');
        var v2 = slide2.querySelector('[data-vvc-video]');
        if (!v2) return;
        v2.muted = !v2.muted;
        updateMuteIcon(slide2, v2.muted);
      }
    });

    // 'ended' no hace bubble, pero sí se puede capturar en fase de captura
    track.addEventListener(
      'ended',
      function (e) {
        if (e.target.matches && e.target.matches('[data-vvc-video]')) next();
      },
      true
    );

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToRealIndex(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    requestAnimationFrame(function () {
      scrollToIndex(Math.floor(setSize), false);
      requestAnimationFrame(onSettled);
    });
  }

  document.querySelectorAll('[data-viral-video-carousel]').forEach(initCarousel);
})();